import { createContext, Dispatch, SetStateAction } from 'react';

export const DialogContext = createContext<{
  close: () => void;
  currentPage: string;
  nextPages: Set<string>;
  opened: boolean;
  pages: Set<string>;
  prevPages: Array<string>;
  rootPage: string;
  setCurrentPage: Dispatch<SetStateAction<string>>;
  setNextPages: Dispatch<SetStateAction<Set<string>>>;
  setPrevPages: Dispatch<SetStateAction<Array<string>>>;
}>({
  close: () => {
    return;
  },
  currentPage: '',
  nextPages: new Set(),
  opened: false,
  pages: new Set(),
  prevPages: [],
  rootPage: '',
  setCurrentPage: () => {
    return;
  },
  setNextPages: () => {
    return;
  },
  setPrevPages: () => {
    return;
  },
});
